import Typography from '@mui/material/Typography';
import * as React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Link } from "react-router-dom";

function Home() {
  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <h2>Your Technology Partner for Custom Software, Product Innovation & Scalable Solutions</h2>

          <Typography style={{ marginTop: 20 }}>
            We are a full-cycle software development company delivering end-to-end solutions for all types of products — web applications, mobile applications, and desktop applications. From ideation to deployment, we handle every stage of the development lifecycle so you can focus on your business.
          </Typography>

          <Typography style={{ marginTop: 20 }}>
            Our services include custom software development, product consulting, IT outsourcing, and dedicated development teams. Whether you need to build a new product from scratch, modernize an existing system, or scale your team with skilled engineers — we deliver trusted technology and long-term value.
          </Typography>

          <Typography style={{ marginTop: 20 }}>
            We also own and operate our own high-performance digital platforms for real estate management — built entirely in-house and tailored for business success.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <h2>Our Product :</h2>

          <h3>Real estate App</h3>
          <Typography>A complete solution for real estate businesses – built for Buyer, Seller and Property Owners without Brokerage.</Typography>
          <Link to="/realestate">Real estate app</Link>

          <h3>Hotel Booking App</h3>
          <Typography>Work in progress, stay tuned for updates!</Typography>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Home;